import { useCallback } from 'react';
import cn from 'bem-cn';

import { ToggleProps } from './Toggle.types';
import './Toggle.scss';

const b = cn('toggle');

export const Toggle = ({ checked, onChange, disabled = false, className }: ToggleProps) => {
    const handleClick = useCallback(() => {
        if (!disabled) {
            onChange(!checked);
        }
    }, [checked, disabled, onChange]);

    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLButtonElement>) => {
            if (!disabled && (event.key === ' ' || event.key === 'Enter')) {
                event.preventDefault();
                onChange(!checked);
            }
        },
        [checked, disabled, onChange],
    );

    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            className={b({ checked, disabled }).mix(className)}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <span className={b('circle')} />
        </button>
    );
};
